const auth = {
  "form": {
    "login": "ログイン",
    "signUp": "会員登録",
    "email": "メールアドレス",
    "password": "パスワード",
    "passwordConfirm": "パスワード確認",
    "forgotPassword": "パスワードをお忘れの方",
    "checkDuplicate": "重複確認",
    "next": "次へ",
    "previous": "前へ",
    "backToLogin": "ログインに戻る",
    "showPassword": "パスワードを表示",
    "hidePassword": "パスワードを隠す",
    "id": "ID",
    "name": "名前",
    "phone": "携帯電話番号",
    "company": "所属",
    "job": "職務",
    "field": "分野",
    "userInfo": "会員情報",
    "verificationCode": "認証コード",
    "resending": "再送信中...",
    "verifying": "確認中...",
    "fieldOptions": {
      "design": "設計",
      "construction": "施工",
      "maintenance": "維持管理",
      "safetyInspection": "安全診断",
      "survey": "測量",
      "agriculture": "農業",
      "environment": "環境"
    }
  },
  "validation": {
    "emailRequired": "メールアドレスを入力してください",
    "emailInvalid": "正しいメールアドレスの形式ではありません",
    "passwordRequired": "パスワードを入力してください",
    "passwordConfirmRequired": "パスワード確認を入力してください",
    "passwordMinLength": "パスワードは8文字以上でなければなりません",
    "nameRequired": "名前を入力してください",
    "phoneRequired": "携帯電話番号を入力してください",
    "phoneInvalid": "正しい携帯電話番号の形式ではありません",
    "companyRequired": "所属を入力してください",
    "jobRequired": "職務を入力してください",
    "fieldRequired": "分野を選択してください",
    "fieldPlaceholder": "選択してください",
    "codeRequired": "認証番号を入力してください",
    "codeSixDigits": "6桁の数字を入力してください"
  },
  "message": {
    "loginFailed": "ログイン失敗",
    "confirmFailed": "認証失敗",
    "resendingConfirmationCode": "認証コードを再送信しました。",
    "confirmationCodeResendingFail": "再送信失敗",
    "fillEmail": "登録済みのメールアドレスを入力してください。",
    "sendCodeNumber": "認証番号をお送りします。",
    "sentCodeNumber": "認証番号が送信されました。",
    "sendCodeNumberFailed": "認証番号送信失敗",
    "changePassWordFailed": "パスワード変更失敗",
    "passwordChangeSuccess": "パスワードが正常に変更されました。",
    "passwordChangeFailed": "パスワード変更失敗",
    "notMatchCode": "認証番号は6桁の数字です。",
    "signUpFailed": "会員登録に失敗しました",
    "signupRetry": "会員登録を完了できませんでした。しばらく後にもう一度お試しください。",
    "finishingSignup": "会員登録が完了していないアカウントです。登録を完了します。",
    "verificationCodeSendFailed": "認証番号送信失敗",
    "verificationCodeSendFailedMessage": "認証番号の送信に失敗しました。もう一度お試しください。",
    "getVerificationCode": "認証番号を受け取る",
    "supersededNotice": "他の端末で同じアカウントでこのアプリにログインしたため、ログアウトされました。続けるには、もう一度ログインしてください。",
    "supersededPartnerNotice": "他の端末で同じアカウントでこのアプリにログインしたため、ログアウトされました。続けるには、Hi-boardからもう一度アクセスしてください。",
    "claimSuperseded": "他の端末でこのアプリに、より新しくログインされました。もう一度ログインしてください。",
    "claimUnavailable": "ログインを確認できませんでした。しばらく後にもう一度お試しください。",
    "autoLoginFailed": "自動ログインに失敗しました。もう一度お試しください。"
  },
  "deviceConflict": {
    "title": "他の端末で使用中のアカウントです",
    "body": "1つのアカウントは、アプリごとに一度に1台の端末でのみログインできます。ここでログインすると、このアプリを使用中の他の端末はログアウトされます。",
    "cancel": "キャンセル",
    "confirm": "ログイン"
  }
} as const;

export default auth;
